import React from "react";

const IconPause = props => (
  <svg
    viewBox="0 0 276 428"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit={1.414}
    {...props}
  >
    <g transform="translate(-391.926)">
      <path fill="none" d="M391.926 0h275.769v427.005H391.926z" />
      <clipPath id="a">
        <path d="M391.926 0h275.769v427.005H391.926z" />
      </clipPath>
      <g clipPath="url(#a)">
        <path d="M392.853 0h110.104v427.004H392.853zM558.518 0h110.104v427.004H558.518z" />
      </g>
    </g>
  </svg>
);

export default IconPause;
